import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
/** lib **/
import { WorriesItemList } from 'lib/worries';
import { IssueList } from 'lib/issue';
/** components **/
import { Layout, FadeUp } from 'components/organisms';
import { IssueItem, WorriesItem } from 'components/molecules';
/** styles **/
import { ReactComponent as BlackCircleArrow } from 'assets/images/black-circle-arrow.svg';
import s from '../styles/pages/worries.module.scss';

// Figmaの掲載順（人見知り・怖がり〜）に合わせる
const orderedIssueList = [...IssueList.slice(6), ...IssueList.slice(0, 6)];

export const Worries: React.FC = () => {
  useEffect(() => {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: '/worries',
      });
    }
  }, []);

  return (
    <Layout>
      <div className={s.worriesPageWrapper}>
        <FadeUp delay={0}>
          <h2 className={s.pageTitle}>ペットと<br className={s.spOnly} />ペットオーナーの悩み</h2>
        </FadeUp>
        <FadeUp delay={0}>
          <h3 className={s.sectionTitle}>ペットオーナーの悩み</h3>
          <div className={s.issueGrid}>
            {orderedIssueList.map((item, index) => (
              <IssueItem
                key={index}
                title={item.title}
                text={item.text}
                image={item.image}
                imageWidth={item.imageWidth}
              />
            ))}
          </div>
        </FadeUp>
        <FadeUp delay={0}>
          <h3 className={classNames(s.sectionTitle, s.voiceTitle)}>言葉にできない、ペットたちの声</h3>
          <div className={s.worriesList}>
            {WorriesItemList.map((item, index) => (
              <WorriesItem
                key={index}
                text={item.text}
                spec={item.spec}
                imageWidth={item.imageWidth}
                image={item.image}
              />
            ))}
          </div>
          <p className={s.note}>※ ペットの声はイメージです</p>
        </FadeUp>
        <Link className={s.topLink} to="/#top">
          <BlackCircleArrow className={s.navButton} />トップページへ戻る
        </Link>
      </div>
    </Layout>
  );
};
